import { NgModule } from '@angular/core';
import { PdfModalComponent } from './pdf-modal.component';
import { TinymceModule } from 'angular2-tinymce';
import { ModalModule } from 'ngx-bootstrap/modal';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { BaseModule } from '../../../shared/base.module';
import { ImageUploadModule } from 'angular2-image-upload';

@NgModule({
    imports: [
        MatSlideToggleModule,
        BaseModule,
        ModalModule.forRoot(),
        TinymceModule.withConfig({
        }),
        ImageUploadModule.forRoot(),
    ],
    exports: [PdfModalComponent],
    declarations: [PdfModalComponent],
    providers: [],
})

export class PdfModalModule {
}
